import { PRODUCTION } from 'src/constants/env'

export default process.env.GATSBY_ENV === PRODUCTION
